import { Component, Input, OnInit, inject } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Tie } from '../../_shared/models/tie.model';
import { TieDetailsService } from '../tie-details/tie-details.service';
import { AuthService } from '../../auth/auth.service';
import { SubscriptionPermissionService } from '../../_shared/services/subscription-permission.service';
import { TranslateService } from '@ngx-translate/core';
interface TieDetailsItem {
    show: boolean;
    dismissCode: string;
    label: string;
    note: string;
    iconColor: string;
    iconName: string;
}

@Component({
  standalone: false,
    selector: 'app-tie-details-popover',
    templateUrl: './tie-details-popover.component.html',
    styleUrls: ['./tie-details-popover.component.scss']
})

export class TieDetailsPopoverComponent implements OnInit {
    private authService = inject(AuthService);
    private popoverCtrl = inject(PopoverController);
    private tieDetailsService = inject(TieDetailsService);
    private subscriptionPermissionService = inject(SubscriptionPermissionService);
    private translateService = inject(TranslateService);
    @Input() tie: Tie;
    isOwner: boolean;
    isOfficial: boolean;

    items: TieDetailsItem[] = [];

    async ngOnInit() {
        this.isOwner = await this.tieDetailsService.isOwner(this.tie);
        this.isOfficial = await this.tieDetailsService.isOfficial(this.tie);

        this.items = [
            {
                show: this.isOwner || this.isOfficial,
                dismissCode: 'add-match-collection',
                label: this.translateService.instant('Add match collection'),
                note: this.translateService.instant('Add additional group of matches to team match'),
                iconColor: 'secondary',
                iconName: 'add'
            },
            {
                show: false,
                dismissCode: 'subscribe-score-updates',
                label: this.translateService.instant('Subscribe to Score updates'),
                note: this.translateService.instant('Get notified when scores are updated for all matches in this team match'),
                iconColor: 'secondary',
                iconName: 'notifications'
            },
            {
                show: true,
                dismissCode: 'apply-lineup',
                label: this.translateService.instant('Apply lineup'),
                note: this.translateService.instant('Apply lineups to team match that are set up on your team profile'),
                iconColor: 'secondary',
                iconName: 'refresh-outline'
            },
            {
                show: true,
                dismissCode: 'change-datetime',
                label: this.translateService.instant('Change date & time'),
                note: this.translateService.instant('Reschedule your team match'),
                iconColor: 'secondary',
                iconName: 'calendar'
            },
            {
                show: this.isIta(),
                dismissCode: 'synchronize-rosters',
                label: this.translateService.instant('Synchronize rosters'),
                note: this.translateService.instant('Pull the the latest rosters from ITA workspace for both teams'),
                iconColor: 'secondary',
                iconName: 'sync-outline'
            },
             {
                show: (this.isOwner || this.isOfficial) && this.isIta(),
                dismissCode: 'submit-lineup',
                label: 'Submit score to ITA',
                note: 'Send lineups and scores to ITA workspace',
                iconColor: 'secondary',
                iconName: 'send'
            },
            {
                show: (this.isOwner || this.isOfficial),
                dismissCode: 'delete',
                label: this.translateService.instant('Delete team match'),
                note: this.translateService.instant('Delete team match. This action cannot be undone'),
                iconColor: 'danger',
                iconName: 'trash'
            },
            {
                show: this.authService.authUserSignal().role?.value > 100,
                dismissCode: 'round',
                label: this.translateService.instant('Round Settings'),
                note: this.translateService.instant('Set round number and round position for a draw'),
                iconColor: 'secondary',
                iconName: 'settings'
            }
        ]
            // this allow to load list once the modal open then check the permission
    this.subscriptionPermissionService.isUserAllowToSubscribeToScore().then(isAllow => {
      if (isAllow) {
        this.items.find(item => item.dismissCode === 'subscribe-score-updates')!.show = isAllow;
      }
    });
    }

    dismiss(action) {
        this.popoverCtrl.dismiss(action);
    }

    isIta(): boolean {
        return this.tie.organisations?.some(o => o.organisationAbbreviation === 'ITA');
    }

}
